// components/buymeacoffee-button.tsx
'use client';

import React from 'react';

type BuyMeACoffeeButtonProps = {
  productUrl: string;
  label?: string;
  className?: string;
};

export function BuyMeACoffeeButton({
  productUrl,
  label = 'Buy Me a Coffee',
  className,
}: BuyMeACoffeeButtonProps) {
  return (
    <a
      href={productUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={
        className ??
        'rounded-lg bg-[#FFDD00] px-6 py-3 font-medium text-black shadow transition hover:brightness-95'
      }
      aria-label={label}
    >
      {label}
    </a>
  );
}
